import { render, staticRenderFns } from "./OutreachNicheView.vue?vue&type=template&id=436b9eb2&"
import script from "./OutreachNicheView.vue?vue&type=script&lang=js&"
export * from "./OutreachNicheView.vue?vue&type=script&lang=js&"
import style0 from "./OutreachNicheView.vue?vue&type=style&index=0&id=436b9eb2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports